import React from 'react';

const ChevronIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="chevron">
    <path d="M9 18L15 12L9 6" stroke="#B8B8B8" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default ChevronIcon;
